import { useContext } from 'react';

import RolesContext from 'contexts/RolesContext';
import USER_ROLES from 'roles';

const useIsViewerRole = () => {
  const { currentRoles } = useContext(RolesContext);
  return currentRoles.includes(USER_ROLES.VIEWER);
};

export default useIsViewerRole;
